import { useLocation, useNavigate } from 'react-router';
import { createBrowserHistory } from 'history';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

import {ReactComponent as Activity} from '../../../assets/img/icon/activity.svg';
import {ReactComponent as Transaction} from '../../../assets/img/icon/transaction.svg';
import {ReactComponent as VoucherIcon} from '../../../assets/img/icon/my-voucher.svg';
// import cv from '../../../assets/img/icon/cv.svg';
import {ReactComponent as Edit} from '../../../assets/img/icon/edit.svg';
import {ReactComponent as Pass} from '../../../assets/img/icon/pass.svg';
import { logout, resetStatus } from '../../../store/redux/actions/auth/login';
// import { useGetProductSettings } from '../../../react-query/general';

const NavigationMenu = ({productName}) => {
  const navigate = useNavigate();
  const history = createBrowserHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  // const { productSettings, loadingProductSettings, errorProductSettings } = useGetProductSettings();
  const logoutStatus = useSelector((state) => state.login.status);
  const role = localStorage.getItem('role')
  const token = localStorage.getItem('token');
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color');

  // const dummyProductName = 'Course';
  // const dummyPluralProductName = 'Courses';
  // const productName = productSettings ? productSettings?.singular_name : dummyProductName;
  // const pluralProductName = productSettings ? productSettings?.plural_name : dummyPluralProductName;


  useEffect(() => {
    if (logoutStatus === 'logged out') {
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'You are logged out!',
      }).then((res) => {
        if (res.isConfirmed) {
          dispatch(resetStatus());
        } else if (res.isDismissed) {
          dispatch(resetStatus());
        }
      });
      localStorage.clear();
    } else if (logoutStatus === 'success logout') {
      navigate('/');
      history.go(0);
    }
  }, [dispatch, history, logoutStatus, navigate]);

  const menuList = [
    {
      title: `My ${productName}`,
      icon: <Activity fill={primaryColor} />,
      link: ['/profile/mycourse', '/profile/detailcourse', '/payment'],
      action: (e) => {
        e.preventDefault();
        navigate('/profile/mycourse');
        history.go(0);
      },
    },
    {
      title: 'My Transactions',
      icon: <Transaction fill={primaryColor} />,
      link: ['/profile/transaction'],
      action: () => navigate('/profile/transaction'),
    },
    {
      title: 'My Vouchers',
      icon: <VoucherIcon fill={primaryColor} />,
      link: ['/profile/voucher'],
      action: (e) => {
        e.preventDefault();
        navigate('/profile/voucher');
        history.go(0);
      },
    },
    // {
    //   title: 'My Curriculum Vitae',
    //   icon: cv,
    //   link: ['/profile/cv'],
    //   action: (e) => {
    //     e.preventDefault();
    //     navigate('/profile/cv');
    //     history.go(0);
    //   },
    // },
    {
      title: 'Edit Profile',
      icon: <Edit fill={primaryColor} />,
      link: ['/profile/edit'],
      action: (e) => {
        e.preventDefault();
        navigate('/profile/edit');
        history.go(0);
      },
    },
    {
      title: 'Change Password',
      icon: <Pass fill={primaryColor} />,
      link: ['/profile/changepassword'],
      action: (e) => {
        e.preventDefault();
        navigate('/profile/changepassword');
      },
    },
    ...(token && role?.toLowerCase() === 'contributor' ? [{
      title: 'Login As Contributor',
      icon: <Edit fill={primaryColor} />,
      link: [''],
      action: (e) => {
        e.preventDefault();
        window.location.href = process.env.REACT_APP_BASE_EDU_URL;
      },
    }] : [])
  ];

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <div className='profile-menu'>
      {menuList.map((item, index) => {
        return (
          <a
            key={index}
            onClick={item.action}
            className={`cursor-pointer ${
              item.link &&item.link.includes(location.pathname) ? 'active' : ''
            }`}
          >
            <p>
              <span>
                {/* <img src={item.icon} alt={Object.keys(item.icon)[0]} /> */}
                {item.icon}
              </span>
              {item.title}
            </p>
          </a>
        );
      })}
      <button
        type='button'
        className='btn btn-outline-green'
        onClick={handleLogout}
      >
        Logout
      </button>
    </div>
  );
};

export default NavigationMenu;
